import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-binglimoban",
  "use": "icon-binglimoban-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-binglimoban\"><path d=\"M139.636364 0h744.727272a93.090909 93.090909 0 0 1 93.090909 93.090909v837.818182a93.090909 93.090909 0 0 1-93.090909 93.090909H139.636364a93.090909 93.090909 0 0 1-93.090909-93.090909V93.090909a93.090909 93.090909 0 0 1 93.090909-93.090909z m186.181818 232.727273H279.272727a46.545455 46.545455 0 1 0 0 93.090909h46.545455v46.545454a46.545455 46.545455 0 1 0 93.090909 0V325.818182h46.545454a46.545455 46.545455 0 1 0 0-93.090909H418.909091V186.181818a46.545455 46.545455 0 1 0-93.090909 0v46.545455z m-46.545455 325.818182a46.545455 46.545455 0 1 0 0 93.090909h465.454546a46.545455 46.545455 0 1 0 0-93.090909H279.272727z m0 186.181818a46.545455 46.545455 0 1 0 0 93.090909h279.272728a46.545455 46.545455 0 1 0 0-93.090909H279.272727z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/binglimoban.svg
// module id = zL/v
// module chunks = 12